// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      gu: {
        translation: {
          // ── Existing keys (kept as-is) ─────────────────────────────────────
          basicShopInfo: "મૂળભૂત દુકાન માહિતી",
          shopName: "દુકાનનું નામ",
          shopType: "દુકાનનો પ્રકાર",
          stallType: "સ્ટોલનો પ્રકાર",
          otherTypeName: "અન્ય પ્રકારનું નામ",
          otherArea: "અન્ય વિસ્તાર",
          area: "વિસ્તાર",
          primaryMobile: "મોબાઇલ નંબર",
          mobileNo2: "મોબાઇલ નંબર ૨",
          mobileNo3: "મોબાઇલ નંબર ૩",
          useDifferentLoginNumbersLabel:
            "જો દુકાન કોઈ બીજા કર્મચારી દ્વારા ખોલવામાં અને બંધ કરવામાં આવતી હોય, તો આ ચેકબોક્સ પર ક્લિક કરો. અન્યથા, ચેકબોક્સ પર ક્લિક ન કરો.",
          loginPrimaryMobile: "લોગિન માટે મોબાઇલ નંબર",
          loginMobileNo2: "લોગિન માટે મોબાઇલ નંબર ૨",
          loginMobileNo3: "લોગિન માટે મોબાઇલ નંબર ૩",
          loginMobilePlaceholder: "લોગિન માટે મોબાઇલ નંબર",
          shopImage: "દુકાનનો ફોટો",
          registeredAddress: "નોંધાયેલ સરનામું",
          geoCoordinates: "ભૌગોલિક અક્ષાંશ-રેખાંશ",
          latitude: "અક્ષાંશ",
          longitude: "રેખાંશ",
          selectOnMap: "નકશા પર સ્થાન પસંદ કરો",
          locationDetails: "સરનામું",
          operatingHours: "કાર્ય સમય",
          startTime: "દુકાન શરૂ કરવાનો સમય",
          endTime: "દુકાન બંધ કરવાનો સમય",
          shopHelpers: "દુકાન સહાયકો",
          addHelper: "વધુ સહાયક ઉમેરો",
          fullName: "પૂરું નામ",
          mobileNumber: "મોબાઇલ નંબર",
          role: "ભૂમિકા",
          manager: "મેનેજર",
          sales: "વેચાણ સહાયક",
          cleaner: "સફાઈકર્મી",
          saveDraft: "ડ્રાફ્ટ તરીકે સાચવો",
          next: "આગળ",
          clickToUpload: "અપલોડ કરવા ક્લિક કરો",
          clickToCapture: "ક્લિક કરીને ફોટો લો",
          dragDrop: "અથવા ફાઇલ અહીં ડ્રેગ કરો (JPG, PNG, GIF - મહત્તમ 5MB)",
          noLocation: "હજુ સુધી સ્થાન પસંદ કરેલ નથી",
          completeCurrentHelpersBeforeAdding: "કૃપા કરીને નવો હેલ્પર ઉમેરતા પહેલાં વર્તમાન હેલ્પરની વિગતો પૂર્ણ કરો.",
          shopAminities: "દુકાનની સુવિધાઓ",

          // Common Validation Messages
          isRequired: "આવશ્યક છે",
          minimumCharacters: "ન્યૂનતમ 3 અક્ષરો હોવા જોઈએ",
          addressTooShort: "સરનામું ખૂબ ટૂંકું લાગે છે",
          invalidLatitude: "અમાન્ય અક્ષાંશ (દા.ત. 23.0225)",
          invalidLongitude: "અમાન્ય રેખાંશ (દા.ત. 72.5714)",
          fileTooLarge: "ફાઇલ ખૂબ મોટી છે (મહત્તમ 5MB)",
          invalidFileType: "માત્ર JPG, JPEG, PNG, GIF માન્ય છે",
          invalidMobile: "અમાન્ય મોબાઇલ નંબર",

          // OwnershipDetails + AgreementUpload - NEW & UPDATED KEYS
          ownershipStatus: "માલિકીની સ્થિતિ",
          shopOwned: "દુકાન મારી માલિકીની",
          shopOwnedDesc: "વિક્રેતા મિલકતનો કાનૂની માલિક છે. માલિકીના પુરાવાની જરૂર છે.",
          shopOnRent: "દુકાન ભાડે છે",
          shopOnRentDesc: "વિક્રેતા મિલકત ભાડે રાખે છે. ભાડા કરાર અને માલિકની વિગતો જરૂરી છે.",
          shopSubTenant: "પેટા ભાડૂઆત",
          shopSubTenantDesc: "વિક્રેતા મુખ્ય ભાડેદાર પાસેથી દુકાન લે છે. પેટા ભાડૂઆત કરાર જરૂરી છે.",
          propertyOwnerDetails: "મિલકત માલિકની વિગતો",
          mainTenantDetails: "મુખ્ય ભાડેદારની વિગતો",
          ownerFullName: "માલિકનું પૂરું નામ",
          ownerMobileNumber: "માલિકનો મોબાઇલ નંબર",
          rentAgreementExpiry: "ભાડા કરારની મુદત પૂરી થવાની તારીખ",
          agreementExpiryDate: "કરારની મુદત પૂરી થવાની તારીખ",
          ownerResidentialAddress: "માલિકનું રહેઠાણનું સરનામું",
          mainTenantName: "મુખ્ય ભાડેદારનું પૂરું નામ",
          mainTenantMobileNo: "મુખ્ય ભાડેદારનો મોબાઇલ નંબર",
          mainTenantAddress: "મુખ્ય ભાડેદારનું રહેઠાણનું સરનામું",
          agreementStartDate: "કરાર શરૂ થવાની તારીખ",
          documents: "દસ્તાવેજો",
          uploadRentAgreement: "ભાડા કરાર અપલોડ કરો",
          uploadSubTenantAgreement: "સબ-ટેનન્સી કરાર અપલોડ કરો",
          expiryAfterStartDate: "મુદત પૂરી થવાની તારીખ શરૂઆતની તારીખ પછીની હોવી જોઈએ",
          startDateBeforeExpiry: "શરૂઆતની તારીખ મુદત પૂરી થવાની તારીખ પહેલાંની હોવી જોઈએ",



          // AgreementUpload - Camera & UI strings
          uploadedSuccessfully: "સફળતાપૂર્વક અપલોડ થયું",
          dragOrClickToUpload: "ડ્રેગ કરો અથવા ક્લિક કરીને ફાઇલ પસંદ કરો",
          maxSize: "મહત્તમ",
          takePhoto: "ફોટો લો",
          galleryOrFile: "ગેલેરી / ફાઇલ",
          capturePhoto: "ફોટો કેપ્ચર કરો",
          cancel: "રદ કરો",
          cameraPermissionDenied: "કેમેરાની પરવાનગી નકારવામાં આવી. બ્રાઉઝર સેટિંગ્સમાં પરવાનગી આપો.",
          cameraErrorFallback: "કેમેરા ખોલી શકાયો નહીં. ગેલેરીમાંથી પસંદ કરવાનો પ્રયાસ કરો.",

          // Other existing keys (OTP, success screen, etc.)
          identityVerificationRequired: "ઓળખ ચકાસણી જરૂરી છે",
          provideOfficialId: "કૃપા કરીને તમારી સત્તાવાર ઓળખ વિગતો નીચે આપો. આ પોલીસ રેકોર્ડ સામે સુરક્ષિત રીતે ચકાસવામાં આવશે.",
          fullLegalName: "દુકાન વપરાશકર્તા નામ",
          mobileContactNumber: "મોબાઇલ સંપર્ક નંબર",
          aadhaarCardNumber: "આધાર કાર્ડ નંબર",
          uploadIdentityProof: "ઓળખ પુરાવો અપલોડ કરો (આધાર કાર્ડ)",
          frontSideAadhaar: "આધાર કાર્ડનો ફોટો",
          backSideAadhaar: "આધારની પાછળની બાજુ",
          secureUpload: "સુરક્ષિત અપલોડ",
          or: "અથવા",
          captureFromCamera: "કેમેરાથી કેપ્ચર કરો",
          back: "પાછળ",
          saveAndContinue: "સાચવો અને આગળ વધો",

          verifyYourMobileNumber: "તમારા મોબાઇલ નંબરની ચકાસણી કરો",
          enterOtpSentTo: "તમારા નોંધાયેલ મોબાઇલ નંબર પર મોકલેલ 6-અંકનો કોડ દાખલ કરો જેનો અંત ...8899 છે.",
          didntReceiveCode: "કોડ મળ્યો નથી?",
          resendIn: "ફરી મોકલવા માટે",
          resendOtp: "OTP ફરી મોકલો",
          verifyAndProceed: "ચકાસો અને આગળ વધો",

          registrationSuccessful: "નોંધણી સફળ!",
          thankYouForRegistering: "ડિપાર્ટમેન્ટ વેન્ડર પોર્ટલ પર નોંધણી કરવા બદલ આભાર. તમારી અરજી સુરક્ષિત રીતે પ્રાપ્ત થઈ છે.",
          vendorId: "વેન્ડર ID",
          confirmationEmailSent: "પુષ્ટિ ઈમેલ તમારા નોંધાયેલ સરનામે મોકલવામાં આવ્યો છે. તમારી અરજી હાલમાં પ્રારંભિક અનુપાલન સમીક્ષા હેઠળ છે.",
          proceedToDashboard: "ડેશબોર્ડ પર જાઓ",
        },
      },

      en: {
        translation: {
          // ── Existing keys ──────────────────────────────────────────────────
          basicShopInfo: "Basic Shop Information",
          shopName: "Shop Name",
          shopType: "Shop Type",
          stallType: "Stall Type",
          otherTypeName: "Other Type Name",
          otherArea: "Other Area",
          area: "Area",
          primaryMobile: "Mobile Number",
          mobileNo2: "Mobile Number 2",
          mobileNo3: "Mobile Number 3",
          useDifferentLoginNumbersLabel:
            "Check this box if the shop is opened and closed by some other employee. Otherwise, leave it unchecked.",
          loginPrimaryMobile: "Login Mobile Number",
          loginMobileNo2: "Login Mobile Number 2",
          loginMobileNo3: "Login Mobile Number 3",
          loginMobilePlaceholder: "Login Mobile Number",
          shopImage: "Shop Image",
          registeredAddress: "Registered Address",
          geoCoordinates: "Geo-Coordinates",
          latitude: "Latitude",
          longitude: "Longitude",
          selectOnMap: "Select Location on Map",
          locationDetails: "Address",
          operatingHours: "Operating Hours",
          startTime: "Shop opening time",
          endTime: "Shop closing time",
          shopHelpers: "Shop Helpers",
          addHelper: "Add Another Helper",
          fullName: "Full Name",
          mobileNumber: "Mobile Number",
          role: "Role",
          manager: "Manager",
          sales: "Sales Assistant",
          cleaner: "Cleaner",
          saveDraft: "Save as Draft",
          next: "Next",
          clickToUpload: "Click to upload",
          clickToCapture: "Click to capture",
          dragDrop: "or drag and drop file here (JPG, PNG, GIF - max 5MB)",
          noLocation: "No location selected yet",
          completeCurrentHelpersBeforeAdding: "Please complete the current helper details before adding a new one.",
          shopAminities: "Shop Amenities",

          isRequired: "is required",
          minimumCharacters: "Minimum 3 characters",
          addressTooShort: "Address seems too short",
          invalidLatitude: "Invalid latitude (e.g. 23.0225)",
          invalidLongitude: "Invalid longitude (e.g. 72.5714)",
          fileTooLarge: "File too large (max 5MB)",
          invalidFileType: "Only JPG, JPEG, PNG, GIF allowed",
          invalidMobile: "Invalid mobile number",

          // Ownership + Upload - NEW KEYS
          ownershipStatus: "Ownership Status",
          shopOwned: "Shop Owned",
          shopOwnedDesc: "The vendor is the legal owner of the property. Requires ownership deed proof.",
          shopOnRent: "Shop on Rent",
          shopOnRentDesc: "The vendor rents the property. Requires rent agreement and owner details.",
          shopSubTenant: "Sub Tenant",
          shopSubTenantDesc: "The vendor sub-rents from the main tenant. Sub-tenancy agreement required.",
          propertyOwnerDetails: "Property Owner Details",
          mainTenantDetails: "Main Tenant Details",
          ownerFullName: "Owner Full Name",
          ownerMobileNumber: "Owner Mobile Number",
          rentAgreementExpiry: "Rent Agreement Expiry Date",
          agreementExpiryDate: "Agreement Expiry Date",
          ownerResidentialAddress: "Owner Residential Address",
          mainTenantName: "Main Tenant Full Name",
          mainTenantMobileNo: "Main Tenant Mobile Number",
          mainTenantAddress: "Main Tenant Residential Address",
          agreementStartDate: "Agreement Start Date",
          documents: "Documents",
          uploadRentAgreement: "Upload Rent Agreement",
          uploadSubTenantAgreement: "Upload Sub-Tenancy Agreement",
          expiryAfterStartDate: "Expiry date must be after the start date",
          startDateBeforeExpiry: "Start date must be before the expiry date",
          uploadedSuccessfully: "Uploaded successfully",
          dragOrClickToUpload: "Drag & drop or click to choose file",
          maxSize: "Max",
          takePhoto: "Take Photo",
          galleryOrFile: "Gallery / File",
          capturePhoto: "Capture Photo",
          cancel: "Cancel",
          cameraPermissionDenied: "Camera permission denied. Please allow access in browser settings.",
          cameraErrorFallback: "Could not open camera. Please try choosing from gallery.",
          doYouHaveRentAgreement: "Do you have rent agreement",
          doYouHaveSubTenantAgreement: "Do you have sub tenant agreement",

          // Other existing keys
          identityVerificationRequired: "Identity Verification Required",
          provideOfficialId: "Please provide your official identification details below. These will be verified securely against police records.",
          fullLegalName: "Shop User Name",
          mobileContactNumber: "Mobile Contact Number",
          aadhaarCardNumber: "Aadhaar Card Number",
          uploadIdentityProof: "Upload Identity Proof (Aadhaar Card)",
          frontSideAadhaar: "Aadhar card photo",
          backSideAadhaar: "Back Side of Aadhaar",
          secureUpload: "Secure Upload",
          or: "OR",
          captureFromCamera: "Capture from Camera",
          back: "Back",
          saveAndContinue: "Save & Continue",

          verifyYourMobileNumber: "Verify Your Mobile Number",
          enterOtpSentTo: "Please enter the 6-digit code sent to your registered mobile number ending in 8899.",
          didntReceiveCode: "Didn't receive the code?",
          resendIn: "Resend in",
          resendOtp: "Resend OTP",
          verifyAndProceed: "Verify & Proceed",

          registrationSuccessful: "Registration Successful!",
          thankYouForRegistering: "Thank you for registering with the Department Vendor Portal. Your application has been securely received.",
          vendorId: "Vendor ID",
          confirmationEmailSent: "A confirmation email has been sent to your registered address. Your application is currently pending initial compliance review.",
          proceedToDashboard: "Proceed To Dashboard",
        },
      },

      hi: {
        translation: {
          // ── Existing keys ──────────────────────────────────────────────────
          basicShopInfo: "दुकान की मूल जानकारी",
          shopName: "दुकान का नाम",
          shopType: "दुकान का प्रकार",
          stallType: "स्टॉल का प्रकार",
          otherTypeName: "अन्य प्रकार का नाम",
          otherArea: "अन्य क्षेत्र",
          area: "क्षेत्र",
          primaryMobile: "मोबाइल नंबर",
          mobileNo2: "मोबाइल नंबर २",
          mobileNo3: "मोबाइल नंबर ३",
          useDifferentLoginNumbersLabel:
            "यदि दुकान किसी अन्य कर्मचारी द्वारा खोली और बंद की जाती है, तो इस चेकबॉक्स पर क्लिक करें। अन्यथा इसे अनचेक छोड़ दें।",
          loginPrimaryMobile: "लॉगिन के लिए मोबाइल नंबर",
          loginMobileNo2: "लॉगिन मोबाइल नंबर २",
          loginMobileNo3: "लॉगिन मोबाइल नंबर ३",
          loginMobilePlaceholder: "लॉगिन मोबाइल नंबर",
          shopImage: "दुकान का फोटो",
          registeredAddress: "पंजीकृत पता",
          geoCoordinates: "भौगोलिक निर्देशांक",
          latitude: "अक्षांश",
          longitude: "देशांतर",
          selectOnMap: "नक्शे पर स्थान चुनें",
          locationDetails: "पता",
          operatingHours: "कार्य समय",
          startTime: "दुकान खोलने का समय",
          endTime: "दुकान बंद करने का समय",
          shopHelpers: "दुकान सहायक",
          addHelper: "अन्य सहायक जोड़ें",
          fullName: "पूरा नाम",
          mobileNumber: "मोबाइल नंबर",
          role: "भूमिका",
          manager: "प्रबंधक",
          sales: "बिक्री सहायक",
          cleaner: "सफाई कर्मी",
          saveDraft: "ड्राफ्ट के रूप में सहेजें",
          next: "आगे",
          clickToUpload: "अपलोड करने के लिए क्लिक करें",
          clickToCapture: "क्लिक करके फोटो लें",
          dragDrop: "या फाइल यहां ड्रैग करें (JPG, PNG, GIF - अधिकतम 5MB)",
          noLocation: "अभी कोई स्थान चुना नहीं गया",
          completeCurrentHelpersBeforeAdding: "कृपया नया हेल्पर जोड़ने से पहले वर्तमान हेल्पर की जानकारी पूरी करें।",
          shopAminities: "दुकान की सुविधाएं",

          isRequired: "आवश्यक है",
          minimumCharacters: "न्यूनतम 3 अक्षर",
          addressTooShort: "पता बहुत छोटा लगता है",
          invalidLatitude: "अमान्य अक्षांश (उदाहरण: 23.0225)",
          invalidLongitude: "अमान्य देशांतर (उदाहरण: 72.5714)",
          fileTooLarge: "फ़ाइल बहुत बड़ी है (अधिकतम 5MB)",
          invalidFileType: "केवल JPG, JPEG, PNG, GIF मान्य हैं",
          invalidMobile: "अमान्य मोबाइल नंबर",

          // Ownership + Upload - NEW KEYS
          ownershipStatus: "स्वामित्व स्थिति",
          shopOwned: "दुकान स्वामित्व में",
          shopOwnedDesc: "विक्रेता संपत्ति का कानूनी मालिक है। स्वामित्व दस्तावेज प्रमाण की आवश्यकता है।",
          shopOnRent: "दुकान किराए पर",
          shopOnRentDesc: "विक्रेता संपत्ति किराए पर लेता है। किराया समझौता और मालिक विवरण आवश्यक हैं।",
          shopSubTenant: "उप किरायेदार",
          shopSubTenantDesc: "विक्रेता मुख्य किरायेदार से उप-किराए पर लेता है। उप-किरायेदारी समझौता आवश्यक है।",
          propertyOwnerDetails: "संपत्ति मालिक विवरण",
          mainTenantDetails: "मुख्य किरायेदार विवरण",
          ownerFullName: "मालिक का पूरा नाम",
          ownerMobileNumber: "मालिक का मोबाइल नंबर",
          rentAgreementExpiry: "किराया समझौते की समाप्ति तिथि",
          agreementExpiryDate: "समझौते की समाप्ति तिथि",
          ownerResidentialAddress: "मालिक का आवासीय पता",
          mainTenantName: "मुख्य किरायेदार का पूरा नाम",
          mainTenantMobileNo: "मुख्य किरायेदार का मोबाइल नंबर",
          mainTenantAddress: "मुख्य किरायेदार का आवासीय पता",
          agreementStartDate: "समझौता प्रारंभ तिथि",
          documents: "दस्तावेज़",
          uploadRentAgreement: "किराया समझौता अपलोड करें",
          uploadSubTenantAgreement: "उप-किरायेदारी समझौता अपलोड करें",
          expiryAfterStartDate: "समाप्ति तिथि प्रारंभ तिथि के बाद होनी चाहिए",
          startDateBeforeExpiry: "प्रारंभ तिथि समाप्ति तिथि से पहले होनी चाहिए",
          uploadedSuccessfully: "सफलतापूर्वक अपलोड किया गया",
          dragOrClickToUpload: "ड्रैग करें या क्लिक करके फाइल चुनें",
          maxSize: "अधिकतम",
          takePhoto: "फोटो लें",
          galleryOrFile: "गैलरी / फाइल",
          capturePhoto: "फोटो कैप्चर करें",
          cancel: "रद्द करें",
          cameraPermissionDenied: "कैमरा अनुमति अस्वीकार कर दी गई। ब्राउज़र सेटिंग्स में अनुमति दें।",
          cameraErrorFallback: "कैमरा खोल नहीं सका। कृपया गैलरी से चुनने का प्रयास करें।",

          // Other existing keys
          identityVerificationRequired: "पहचान सत्यापन आवश्यक",
          provideOfficialId: "कृपया नीचे अपनी आधिकारिक पहचान विवरण प्रदान करें। इनकी पुलिस रिकॉर्ड के खिलाफ सुरक्षित सत्यापन किया जाएगा।",
          fullLegalName: "दुकान उपयोगकर्ता नाम",
          mobileContactNumber: "मोबाइल संपर्क नंबर",
          aadhaarCardNumber: "आधार कार्ड नंबर",
          uploadIdentityProof: "पहचान प्रमाण अपलोड करें (आधार कार्ड)",
          frontSideAadhaar: "आधार कार्ड फोटो",
          backSideAadhaar: "आधार का पीछे का हिस्सा",
          secureUpload: "सुरक्षित अपलोड",
          or: "या",
          captureFromCamera: "कैमरे से कैप्चर करें",
          back: "पीछे",
          saveAndContinue: "सहेजें और जारी रखें",

          verifyYourMobileNumber: "अपना मोबाइल नंबर सत्यापित करें",
          enterOtpSentTo: "कृपया अपने पंजीकृत मोबाइल नंबर पर भेजा गया 6-अंकीय कोड दर्ज करें जो 8899 पर समाप्त होता है।",
          didntReceiveCode: "कोड नहीं मिला?",
          resendIn: "दोबारा भेजें",
          resendOtp: "OTP दोबारा भेजें",
          verifyAndProceed: "सत्यापित करें और आगे बढ़ें",

          registrationSuccessful: "पंजीकरण सफल!",
          thankYouForRegistering: "विभाग वेंडर पोर्टल पर पंजीकरण करने के लिए धन्यवाद। आपका आवेदन सुरक्षित रूप से प्राप्त हो गया है।",
          vendorId: "वेंडर ID",
          confirmationEmailSent: "एक पुष्टिकरण ईमेल आपके पंजीकृत पते पर भेज दिया गया है। आपका आवेदन वर्तमान में प्रारंभिक अनुपालन समीक्षा के अधीन है।",
          proceedToDashboard: "डैशबोर्ड पर जाएं",
        },
      },
    },
    lng: 'gu',           // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;